"use client";

import { createContext, useContext } from "react";

const OpenCityContext = createContext<(city: string) => void>(() => {});

/**
 * Provides "open this city's detailed flight costs" to cells deep in the comparison.
 * @throws Never.
 */
export const OpenCityProvider = OpenCityContext.Provider;

/**
 * Opens a destination's detailed flight costs.
 * @returns A function taking the destination city.
 * @throws Never.
 */
export const useOpenCity = () => useContext(OpenCityContext);
